import { Grid } from 'ui-toolkit';
import styled from 'styled-components';

export const NoGapGrid = styled(Grid)`
  gap: 0px;
`;
